import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll the window
    window.scrollTo(0, 0);
    
    // Also try scrolling the document element and body
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Find and scroll any scrollable parent containers
    const scrollContainers = document.querySelectorAll('.App, main, #root');
    scrollContainers.forEach(container => {
      if (container.scrollTop > 0) {
        container.scrollTop = 0;
      }
    });

    // Fallback with requestAnimationFrame for browsers that need it
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
  }, [pathname]);

  return null;
}

export default ScrollToTop;